import { getUACode } from '@/methods/getUAData'
import { ENVIORNMENT } from '@/constants/config'

const deployEnv = process.env.DEPLOY_ENV as string
const isPreOrProdDeploy = deployEnv === ENVIORNMENT.PRE || deployEnv === ENVIORNMENT.PROD

function getHostForUrlAndBpsPortQuery(
  socketHost: string,
  wscdn: string,
): { hostForUrl: string; portQs: string } {
  let hostForUrl = socketHost
  let portQs = ''
  if (wscdn === 'bps' && isPreOrProdDeploy) {
    const m = socketHost.match(/^(.+?):(\d+)$/)
    if (m) {
      hostForUrl = m[1]
      portQs = `&port=${m[2]}`
    }
  }
  return { hostForUrl, portQs }
}

export function buildRoomSocketUrl(
  socketHost: string,
  socketToken: string,
  socketRegion: string,
  wscdn: string,
): string {
  if (socketHost === '') {
    return ''
  }
  const { hostForUrl, portQs } = getHostForUrlAndBpsPortQuery(socketHost, wscdn)
  return `https://${hostForUrl}?t=${socketToken}&r=${socketRegion}&o=${getUACode()}&EIO=3&transport=websocket${portQs}`
}
